(function() {
  'use strict';

  // === CONFIGURATIE ===
  const REVIEWSCOUK_STORE_ID = 'YOUR_STORE_ID'; // <-- VERVANG DIT MET JE REVIEWS.CO.UK STORE ID

  // === HELPER: Format prijs ===
  function formatMoney(cents) {
    const euros = Math.floor(cents / 100);
    return '€' + euros.toLocaleString('nl-NL');
  }

  // === CONDITIE KNOPPEN ===
  function initConditionButtons() {
    document.querySelectorAll('.nextmac-conditions').forEach(wrapper => {
      const buttons = wrapper.querySelectorAll('.nextmac-condition-btn');
      const card = wrapper.closest('.card');
      if (!card) return;

      const productId = card.dataset.productId;
      const priceEl = card.querySelector('[data-product-price]');
      const savingsEl = card.querySelector('[data-product-savings]');
      
      let productData = null;
      const dataEl = document.querySelector(`[data-product-variants="${productId}"]`);
      if (dataEl) {
        try {
          productData = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.warn('NextMac: Could not parse product data');
        }
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          
          buttons.forEach(b => b.classList.remove('nextmac-condition-btn--active'));
          this.classList.add('nextmac-condition-btn--active');
          
          const newPrice = parseInt(this.dataset.price, 10);
          if (priceEl && !isNaN(newPrice)) {
            priceEl.textContent = formatMoney(newPrice);
          }
          
          if (savingsEl && productData && productData.nieuwprijs) {
            const besparing = productData.nieuwprijs - newPrice;
            if (besparing > 0) {
              savingsEl.textContent = 'bespaar ' + formatMoney(besparing);
              savingsEl.style.display = '';
            } else {
              savingsEl.style.display = 'none';
            }
          }
        });
      });
    });
  }

  // === REVIEWS.CO.UK ===
  function loadReviewsScript() {
    if (document.querySelector('script[src*="reviews.co.uk"]')) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://widget.reviews.co.uk/product/dist.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initReviews() {
    const widgets = document.querySelectorAll('.reviewscouk-product-badge');
    if (widgets.length === 0) return;

    loadReviewsScript().then(() => {
      if (typeof window.reviewsBadgeRibbon === 'function') {
        widgets.forEach(widget => {
          const sku = widget.dataset.sku;
          if (sku) {
            window.reviewsBadgeRibbon('ruk_rating_snippet', {
              store: REVIEWSCOUK_STORE_ID,
              sku: sku,
              lang: 'nl'
            });
          }
        });
      }
    }).catch(err => {
      console.warn('NextMac: Reviews widget failed to load');
    });
  }

  // === INITIALISATIE ===
  function init() {
    initConditionButtons();
    initReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Observer voor dynamisch geladen content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('.nextmac-conditions')) {
          init();
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();